import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const TrendUpIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 17l6-6 4 4 8-8"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M21 7v4h-4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

TrendUpIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(TrendUpIcon);
